import React, { useEffect, useState } from 'react';
import { Check, CheckCheck } from 'lucide-react';
import { api, getAuthHeaders } from '../utils/api';
import Loader from "../components/Loader";

const NotificationPopup = ({ onClose, onViewAll, onMarkAsRead, setApiUnreadCount }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [total, setTotal] = useState(0);

  const fetchNotifications = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get('/notifications?page=1&limit=20', {
        headers: getAuthHeaders(),
      });
      setNotifications(response.data.results || []);
      setTotal(response.data.unreadCount || response.data.total || 0);
    } catch (err) {
      setError('Failed to load notifications.');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchNotifications();
  }, []);
 const formatNotificationTime = (updatedAt) => {
    if (!updatedAt) return '';
    const updatedDate = new Date(updatedAt);
    const now = new Date();
    const diffMs = now - updatedDate;
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (diffDays >= 1) {
      // Format as DD-MM-YYYY
      const day = String(updatedDate.getDate()).padStart(2, '0');
      const month = String(updatedDate.getMonth() + 1).padStart(2, '0');
      const year = updatedDate.getFullYear();
      return `${day}-${month}-${year}`;
    } else if (diffHours >= 1) {
      return `${diffHours} hr. ago`;
    } else {
      return `${diffMinutes} min. ago`;
    }
  };
  const getNotificationIcon = (priority) => {
    const iconMap = {
      urgent: '!',
      high: '!',
      low: 'i',
      medium: '✓'
    };
    return iconMap[priority] || 'i';
  };

  const unreadNotifications = notifications.filter(n => !n.read);

  const markAllAsRead = async () => {
    try {
      if (unreadNotifications.length === 0) return;
      await api.put('/notifications/actions/read-all', {}, { headers: getAuthHeaders() });
      fetchNotifications();
      const res = await api.get('/notifications/analytics/unread-count', { headers: getAuthHeaders() });
      setApiUnreadCount(res.data?.unreadCount || 0);
    } catch (e) {
      // Optionally show error toast
    }
  };

const markAsRead = async (id) => {
  console.log('Marking as read:', id);
    try {
      await api.put(`/notifications/${id}/read`, {}, { headers: getAuthHeaders() });
      await fetchNotifications();
      const res = await api.get('/notifications/analytics/unread-count', { headers: getAuthHeaders() });
      setApiUnreadCount(res.data?.unreadCount || 0);
    } catch (e) {
      // Optionally show error toast
    }
  };


  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <>
      <div className="notification-overlay" onClick={onClose}></div>
      <div className="notification-popup">
        <div className="notification-popup-header">
          <div className="notification-header-left">
            <span className="notification-title">Notification</span>
            <span className="notification-count">{total}</span>
          </div>
          {unreadNotifications.length > 0 && (
          <button 
            className="mark-all-read-btn"
            onClick={markAllAsRead}
          >
            <CheckCheck className="mark-all-icon" />
            Mark all as read
          </button>
          )}
        </div>

        <div className="notification-popup-body">
          {/* {loading && <div className="notification-loading"><Loader /></div>} */}
          {error && <div className="notification-error">{error}</div>}
          {!loading && !error && unreadNotifications.length === 0 && (
            <div className="no-unread-notifications" style={{ textAlign: 'center', padding: '20px' }}>
              <p>No unread message available</p>
            </div>
          )}
          {!loading && !error && unreadNotifications.slice(0, 4).map((notification) => (
            <div 
              key={notification.id} 
              className={`notification-item ${!notification.read ? 'unread' : ''}`}
            >
              <div className="notification-content">
                <div className={`notification-icon ${notification.priority}`}>
                  {getNotificationIcon(notification.priority)}
                  {!notification.read && <div className="unread-dot"></div>}
                </div>
                <div className="notification-text">
                  <p className={`notification-message ${!notification.read ? 'unread-text' : ''}`}>
                    {notification.text}
                  </p>
                  <span className="notification-time">{formatNotificationTime(notification.createdAt || notification.updatedAt)}</span>
                </div>
              </div>
              {!notification.read && (
                <button 
                  className="mark-read-btn"
                  onClick={() => markAsRead(notification._id)}
                  title="Mark as read"
                >
                  <Check className="check-icon" />
                </button>
              )}
            </div>
          ))}
        </div>

        <div className="notification-popup-footer">
          <button className="view-all-notification-btn" onClick={onViewAll}>
            View all notifications →
          </button>
        </div>
      </div>
    </>
  );
};

export default NotificationPopup;